module.exports = __webpack_public_path__ + "static/anushka-wagle-eba721f857fb7ae5ad42e54601a4de1d.jpeg";